export default "__VITE_ASSET__BhgmQRMo__"